import AmericanWaltz from './american-waltz';
import ArgentineTangoLead from './argentine-tango-lead';
import ArgentineTangoFollow from './argentine-tango-follow';
import AustrianWaltzLead from './austrian-waltz-lead';
import AustrianWaltzFollow from './austrian-waltz-follow';
import Blues from './blues';
import TangoCanasta from './tango-canasta';
import ChaCha from './cha-cha';
import ChaChaCongelado from './cha-cha-congelado';
import DutchWaltz from './dutch-waltz';
import EuropeanWaltz from './european-waltz';
import TangoFiesta from './tango-fiesta';
import FinnstepLead from './finnstep-lead';
import FinnstepFollow from './finnstep-follow';
import Foxtrot from './foxtrot';
import GoldenWaltzLead from './golden-waltz-lead';
import GoldenWaltzFollow from './golden-waltz-follow';
import HickoryHoedown from './hickory-hoedown';
import Kilian from './kilian';
import MidnightBluesLead from './midnight-blues-lead';
import MidnightBluesFollow from './midnight-blues-follow';
import PasoDobleLead from './paso-doble-lead';
import PasoDobleFollow from './paso-doble-follow';
import Quickstep from './quickstep';
import RavensburgerWaltzLead from './ravensburger-waltz-lead';
import RavensburgerWaltzFollow from './ravensburger-waltz-follow';
import Rhumba from './rhumba';
import RhythmBlues from './rhythm-blues';
import RockerFoxtrot from './rocker-foxtrot';
import SilverSambaLead from './silver-samba-lead';
import SilverSambaFollow from './silver-samba-follow';
import StarlightWaltzLead from './starlight-waltz-lead';
import StarlightWaltzFollow from './starlight-waltz-follow';
import SwingDance from './swing-dance';
import Tango from './tango';
import TangoRomanticaLead from './tango-romantica-lead';
import TangoRomanticaFollow from './tango-romantica-follow';
import TeaTimeFoxtrotLead from './tea-time-foxtrot-lead';
import TeaTimeFoxtrotFollow from './tea-time-foxtrot-follow';
import TenFox from './ten-fox';
import VienneseWaltzLead from './viennese-waltz-lead';
import VienneseWaltzFollow from './viennese-waltz-follow';
import WestminsterWaltzLead from './westminster-waltz-lead';
import WestminsterWaltzFollow from './westminster-waltz-follow';
import WillowWaltz from './willow-waltz';
import YankeePolkaLead from './yankee-polka-lead';
import YankeePolkaFollow from './yankee-polka-follow';

const patterns = {
    AmericanWaltz,
    ArgentineTangoLead,
    ArgentineTangoFollow,
    AustrianWaltzLead, 
    AustrianWaltzFollow,
    Blues,
    ChaCha,
    ChaChaCongelado,
    DutchWaltz,
    EuropeanWaltz,
    FinnstepLead,
    FinnstepFollow,
    Foxtrot,
    GoldenWaltzLead,
    GoldenWaltzFollow, 
    HickoryHoedown,
    Kilian,
    MidnightBluesLead, 
    MidnightBluesFollow,
    PasoDobleLead,
    PasoDobleFollow,
    Quickstep,
    RavensburgerWaltzLead,
    RavensburgerWaltzFollow,
    Rhumba,
    RhythmBlues,
    RockerFoxtrot,
    SilverSambaLead,
    SilverSambaFollow, 
    StarlightWaltzLead,
    StarlightWaltzFollow,
    SwingDance,
    Tango,
    TangoCanasta,
    TangoFiesta,
    TangoRomanticaLead,
    TangoRomanticaFollow,
    TeaTimeFoxtrotLead,
    TeaTimeFoxtrotFollow,
    TenFox,
    VienneseWaltzLead, 
    VienneseWaltzFollow,
    WestminsterWaltzLead,
    WestminsterWaltzFollow, 
    WillowWaltz,
    YankeePolkaLead,
    YankeePolkaFollow,
}

export default patterns;

/*
Preliminary - 2
    Dutch Waltz
    Canasta Tango
    Rhythm Blues

Pre-Bronze - 2
    Swing Dance
    Cha Cha
    Fiesta Tango

Bronze - 2
    Hickory Hoedown
    Willow Waltz
    Ten-Fox

Pre-Silver - 2
    Forteenstep
    European Waltz
    Foxtrot

Silver - 2
    American Waltz
    Tango
    Rocker Foxtrot

Pre-Gold - 4
    Kilian
    Blues
    Paso Doble - Lead
    Paso Doble - Follow
    Starlight Waltz - Lead
    Starlight Waltz - Follow

Gold - 4
    Viennese Waltz - Lead
    Viennese Waltz - Follow
    Westminster Waltz - Lead
    Westminster Waltz - Follow
    Quickstep
    Argentine Tango - Lead
    Argentine Tango - Follow

===== 18 + 2 ===== $16

International - 11
    Austrian Waltz - Lead
    Austrian Waltz - Follow
    Cha Cha Congelado
    Finnstep - Lead
    Finnstep - Follow
    Golden Waltz - Lead
    Golden Waltz - Follow
    Midnight Blues - Lead
    Midnight Blues - Follow
    Ravensburger Waltz - Lead
    Ravensburger Waltz - Follow
    Rhumba
    Silver Samba - Lead
    Silver Samba - Follow
    Tango Romantica - Lead
    Tango Romantica - Follow
    Tea-Time Foxtrot - Lead
    Tea-Time Foxtrot - Follow
    Yankee Polka - Lead
    Yankee Polka - Follow

===== 11 + 2 ===== $10

.28/ea for 10 mil 3-1/2 x 5-1/2 sleeve
.10/ea for 110lb 3x5 index card
.15/ea for 1" binder ring
*/